<app-menu>
  <div class="header">
    <div class="header-title">
      <h1 class="title">Store Report</h1>

      <div class="other-pages">
        <button mat-raised-button (click)="openExceptionReports()" class="nav-btn">
          Exception Reports
        </button>
        <button mat-raised-button (click)="openDeliveryReports()" class="nav-btn">
          Delivery Reports
        </button>
      </div>
    </div>

    <div class="header-btns">
      <div class="exports">
        <button (click)="exportToCSV()"   mat-raised-button class="export-btn">CSV</button>
        <button (click)="exportToExcel()" mat-raised-button class="export-btn">Excel</button>
        <!-- <button (click)="downloadBestChart()" mat-raised-button class="export-btn">Chart</button> -->
      </div>

      <!-- ultra-compact native search -->
      <input
        type="text"
        class="quick-filter-input"
        placeholder="Search…"
        (input)="onQuickFilterInput($any($event.target).value)" />

      <!-- YOUR ORIGINAL TOGGLE MARKUP (unchanged) -->
      <button (click)="toggleTheme()" class="header-btn toggle-grid-mode-btn">
        <mat-icon>{{ theme === 'ag-theme-ulaap' ? 'nights_stay' : 'wb_sunny' }}</mat-icon>
      </button>
    </div>
  </div>

  <div class="grid-wrapper">
    <ag-grid-angular
      *ngIf="gridReady"
      #agGrid
      style="width: 100%; height: 100%;"
      [class]="theme"
      [gridOptions]="gridOptions"
      [rowData]="rowData"
      [defaultColDef]="defaultColDef"
      [columnDefs]="columnDefs"
      [initialState]="initialState"
      (gridReady)="onGridReady($event)"
      (stateUpdated)="onStateUpdated($event)">
    </ag-grid-angular>
  </div>

  <!-- hidden scratchpad for PNG chart rendering -->
  <div id="chartScratchpad" class="sr-only" aria-hidden="true"></div>
</app-menu>

<app-lading-status-modal
  *ngIf="isStatusModalOpen"
  (closeModal)="closeStatusModal($event)"
  [lading_uuid]="lading_uuid">
</app-lading-status-modal>
